module.exports = __webpack_public_path__ + "img/air-max-2090-womens-shoe.54d1db13.png";